module.exports = __webpack_public_path__ + "static/media/food.4d1548d8.jpg";